import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const CostForm_VariableCost_Fragment = graphql(`
  fragment CostForm_VariableCost_Fragment on VariableCost {
    _id
    typeId
    codingConfig {
      kind
      strategyId
      ... on CodingConfigManual {
        code
      }
      ...CodeCmp_CodingConfig_Fragment
    }
    code
    label
    costMarginId
    title
    content
    statusId
    value
  }
`);

export type CostForm_VariableCostData = ResultOf<
  typeof CostForm_VariableCost_Fragment
>;

// The form edits a readable value: a cost whose value is confidential is not editable.
export type CostForm_VariableCost = Omit<CostForm_VariableCostData, 'value'> &
  Readonly<{ value: number }>;
